import { TAvailableConfigValues } from '@customTypes/common';

export interface IFragmentsFilterConfig {
  reportInconsistentTracks: boolean;
  filterOutInconsistentTracks: boolean;
}

export const defaultFragmentsFilterConfig: IFragmentsFilterConfig = {
  reportInconsistentTracks: true,
  filterOutInconsistentTracks: false,
};

export const availableFragmentsFilterConfigValues: TAvailableConfigValues<IFragmentsFilterConfig> = {};
